package dairy.mynotes.utils

actual fun formatDate(epochMillis: Long): String {
    if (epochMillis == 0L) return ""
    return try {
        @Suppress("UNUSED_VARIABLE")
        val ms = epochMillis.toDouble()
        val date = js("new Date(ms)")
        val day = (date.getDate().unsafeCast<Int>()).toString().padStart(2, '0')
        val month = (date.getMonth().unsafeCast<Int>() + 1).toString().padStart(2, '0')
        val year = date.getFullYear().unsafeCast<Int>()
        "$day/$month/$year"
    } catch (_: Exception) {
        ""
    }
}

